const styles = {
  container: { 
    padding: "20px", 
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#f4f6f9",
    minHeight: "100vh",
    transition: "margin-left 0.3s ease"
  },
  header: { 
    color: "#1B019B", 
    fontSize: "28px", 
    fontWeight: "bold", 
    marginBottom: "20px" 
  },
  organisationHeader: {
    backgroundColor: '#fff', 
    padding: '20px', 
    borderRadius: '12px', 
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    marginBottom: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  organisationButton: {
    padding: '12px 20px',
    border: '2px solid #1B019B',
    borderRadius: '8px',
    backgroundColor: '#fff',
    color: '#1B019B',
    fontWeight: '600',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    cursor: 'pointer',
    minWidth: '300px'
  },
  organisationDropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    border: '2px solid #1B019B',
    borderTop: 'none',
    borderRadius: '0 0 8px 8px',
    maxHeight: '200px',
    overflowY: 'auto',
    zIndex: 1000
  },
  organisationItem: {
    padding: '12px 20px',
    cursor: 'pointer',
    borderBottom: '1px solid #eee',
  },
  filterBar: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#f8f9fa",
    padding: "15px",
    borderRadius: "8px",
    boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
    marginBottom: "20px",
    gap: "15px",
  },
  addButton: {
    backgroundColor: "#1B019B",
    color: "white",
    padding: "10px 15px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    flex: "1 1 200px",
    minWidth: "150px",
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
    flex: "2 1 300px",
    minWidth: "250px",
  },
  searchInput: {
    padding: "10px",
    width: "100%",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
  countBadge: {
    fontWeight: "bold",
    color: "#1B019B",
    flex: "1 1 150px",
    textAlign: "right",
    minWidth: "100px",
  },
  table: {
    width: "100%", 
    borderCollapse: "collapse", 
    backgroundColor: "white",
    borderRadius: "10px", 
    overflow: "hidden",
    boxShadow: "0px 4px 8px rgba(0,0,0,0.1)"
  },
  tableHeader: {
    backgroundColor: "#1B019B", 
    color: "white", 
    height: "60px" 
  },
  statusBadge: (isActive) => ({
    padding: "4px 8px",
    borderRadius: "12px",
    backgroundColor: isActive ? "#d4edda" : "#f8d7da",
    color: isActive ? "#155724" : "#721c24",
    fontSize: "12px"
  }),
  actionButton: {
    border: "none",
    borderRadius: "4px", 
    padding: "6px 8px", 
    cursor: "pointer"
  },
  viewButton: {
    backgroundColor: "#17a2b8", 
    color: "white"
  },
  editButton: {
    backgroundColor: "#ffc107", 
    color: "black"
  },
  deleteButton: {
    backgroundColor: "#dc3545", 
    color: "white"
  },
  modalOverlay: {
    position: "fixed", 
    top: 0, 
    left: 0, 
    width: "100vw", 
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1000, 
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center",
  },
  modalContent: {
    backgroundColor: "#fff", 
    padding: "30px", 
    borderRadius: "12px",
    width: "650px", 
    maxHeight: "90vh", 
    overflowY: "auto", 
    position: "relative",
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)"
  },
  closeButton: {
    position: "absolute", 
    top: "10px", 
    right: "10px",
    background: "transparent", 
    border: "none", 
    fontSize: "22px",
    cursor: "pointer", 
    color: "#999"
  },
  modalTitle: {
    textAlign: "center", 
    color: "#1e3c72", 
    marginBottom: "25px", 
    fontSize: "24px"
  },
  formGroup: {
    marginBottom: "15px"
  },
  formInput: {
    width: "100%",
    padding: "8px",
    marginTop: "5px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    fontSize: "14px"
  },
  formSelect: {
    width: "100%",
    padding: "8px",
    marginTop: "5px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    fontSize: "14px",
    height: "100px"
  },
  formRow: {
    display: "flex", 
    gap: "15px", 
    marginBottom: "15px" 
  },
  submitButton: {
    backgroundColor: "#1e3c72", 
    color: "white", 
    padding: "10px 20px",
    borderRadius: "5px", 
    border: "none", 
    cursor: "pointer",
    fontSize: "16px"
  },
  navigationButton: {
    padding: '8px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    cursor: 'pointer',
    minWidth: '200px',
    justifyContent: 'center',
  },
  primaryNavButton: {
    borderRadius: '8px 0 0 8px',
    border: '1px solid #1B019B',
    backgroundColor: '#1B019B',
    color: 'white',
  },
  secondaryNavButton: {
    borderRadius: '0 8px 8px 0',
    border: '1px solid #1B019B',
    backgroundColor: '#fff',
    color: '#1B019B',
  }
};

export default styles;